export default __webpack_public_path__ + "76a479ffb0dc548b3694868700edd575.png";